import React from 'react';
import { Button } from '@/components/ui/button';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { RefreshCw, Download } from 'lucide-react';
import { useAppUpdate } from '@/hooks/useAppUpdate';

export const UpdateNotification: React.FC = () => {
  const { updateAvailable, isUpdating, applyUpdate } = useAppUpdate();

  if (!updateAvailable) return null;

  return (
    <Alert className="mb-4 border-primary/50 bg-primary/5">
      <Download className="h-4 w-4" />
      <AlertDescription className="flex items-center justify-between">
        <span>Nueva versión disponible. Actualiza para obtener las últimas mejoras.</span>
        <Button
          onClick={applyUpdate}
          disabled={isUpdating}
          size="sm"
          className="ml-4"
        >
          <RefreshCw className={`h-3 w-3 mr-1 ${isUpdating ? 'animate-spin' : ''}`} />
          {isUpdating ? 'Actualizando...' : 'Actualizar'}
        </Button>
      </AlertDescription>
    </Alert>
  );
};